import apiClient from "../../lib/apiClient";

export const commentsAPI = {
  // GET /api/comments/review/:reviewId
  getCommentsByReview: async (reviewId, params = {}) => {
    try {
      const response = await apiClient.get(`/comments/review/${reviewId}`, {
        params,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || "Lấy danh sách comment thất bại",
      };
    }
  },

  // GET /api/comments/:id/replies
  getReplies: async (commentId, params = {}) => {
    try {
      const response = await apiClient.get(`/comments/${commentId}/replies`, {
        params,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy danh sách reply thất bại",
      };
    }
  },

  // POST /api/comments
  createComment: async (commentData) => {
    try {
      const response = await apiClient.post("/comments", commentData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Tạo comment thất bại",
      };
    }
  },

  // PUT /api/comments/:id
  updateComment: async (id, content) => {
    try {
      const response = await apiClient.put(`/comments/${id}`, { content });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Cập nhật comment thất bại",
      };
    }
  },

  // DELETE /api/comments/:id
  deleteComment: async (id) => {
    try {
      const response = await apiClient.delete(`/comments/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Xóa comment thất bại",
      };
    }
  },
};
